import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workers-list',
  templateUrl: './workers-list.component.html',
  styleUrls: ['./workers-list.component.css']
})
export class WorkersListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
